import { useEffect } from 'react';

import { VisaStatus } from 'types';

import { VisaApplied } from './components/VisaApplied';
import { IVisaStatus } from '../../../../../../../../types';

interface IProps {
  status: IVisaStatus;
  setComplete: (status: boolean) => void;
  visaStatus: IVisaStatus;
  selectedStatus: {
    setStatus: (status: IVisaStatus) => void;
  };
}

export const AdditionalQuestions = (props: IProps) => {
  const {
    status,
    visaStatus,
    selectedStatus: { setStatus },
    setComplete
  } = props;
  useEffect(() => {
    if (
      status !== VisaStatus.NONE && // disables submit button
      status !== VisaStatus.VISA_APPLIED &&
      status !== visaStatus // prevents setting status to same value
    ) {
      setComplete(true);
    }
  }, [setComplete, status, visaStatus]);

  if (status === VisaStatus.VISA_APPLIED && visaStatus !== VisaStatus.VISA_APPLIED) {
    // only show if student currently clicked on visa applied, not through email
    return <VisaApplied additionalAnswers={{ setStatus }} setComplete={setComplete} />;
  }

  return <></>;
};
